export const createDirectLinkStore = (set) => ({
	redirectPath: null,
	setRedirectPath: (path) =>
		set({ redirectPath: path }, false, { type: 'redirectPath/set', path }),
	clearRedirectPath: () =>
		set({ redirectPath: null }, false, { type: 'redirectPath/clear' })
})
